import { render, staticRenderFns } from "./TermsAndConditionsMobile.vue?vue&type=template&id=31db118e&scoped=true"
import script from "./TermsAndConditionsMobile.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditionsMobile.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditionsMobile.vue?vue&type=style&index=0&id=31db118e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31db118e",
  null
  
)

export default component.exports